import request from "../../../../core/data/network/client/request";
import Api from "../../../../core/data/network/constants/api_routes";

export default {
  getTecnicalSupport: async (pagination, term) => {
    return request.get(Api.getSupport(pagination, term));
  },
  getTecnicalSupportDetail: async (term) => {
    return request.get(Api.getSupportById(term));
  },
  getTecnicalSupportFile: async (id) => {
    return request.get(Api.getSupportDownload(id));
  },
  updateTechnicalSupport: async (id, data) => {
    return request.patch(Api.updateTechnicalSupport(id), data);
  },   
};